import { ENV } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";
import { isNullOrEmpty } from "../config/ENV";

export async function getEnumLists() {
  if (
    isNullOrEmpty(
      window.localStorage.getItem("teamanics_enumaration_constants")
    )
  ) {
    const { data } = await axiosInterceptors.get(ENV.jobMetaDataEnumsUrl);
    if(data!=null){
      window.localStorage.setItem(
        "teamanics_enumaration_constants",
        JSON.stringify(data)
      );
    }   
    return data;
  } else {
    var teamanics_enumaration_constants_list = JSON.parse(
      window.localStorage.getItem("teamanics_enumaration_constants")
    );
    return teamanics_enumaration_constants_list;
  }
}


export async function getUserMetaEnums() {
  if (
    isNullOrEmpty(
      window.localStorage.getItem("teamanics_job_enumaration_constants")
    )
  ) {
    const { data } = await axiosInterceptors.get(ENV.jobMetaDataEnumsUrl);
    if(data!=null){
      window.localStorage.setItem(
        "teamanics_job_enumaration_constants",
        JSON.stringify(data)
      );
    }   
    return data;
  } else {
    var teamanics_job_enumaration_constants_list = JSON.parse(
      window.localStorage.getItem("teamanics_job_enumaration_constants")
    );
    return teamanics_job_enumaration_constants_list;
  }
}